const ko = {
  Language: {
    vi: "베트남어",
    en: "영어",
    zh: "중국어（간체）",
    "zh-HK": "중국어（번체, 홍콩）",
    ko: "한국어",
    ja: "일본어",
  },
  NAVS: {
    home: "홈",
    ourHotels: "호텔 소개",
    contactUs: "문의하기",
    aboutUs: "회사 소개",
    sustainability: "지속가능성",
    careers: "채용",
    discoverOurHotels: "호텔 둘러보기",
    amanakiSaigonBoutique: "아마나키 사이공 부티크",
    amanakiThaoDien: "아마나키 타오디엔",
    amanakiHotel: "아마나키 호텔",
    theHotel: "호텔",
    brandStory: "브랜드 스토리",
    artAmanaki: "아트 & 아마나키",
    rooms: "객실",
    wellness: "웰니스",
    dining: "다이닝",
    events: "이벤트",
    offers: "특가",
    discoverSaigon: "사이공 둘러보기",
  },
  Form: {
    required: "필수 입력 항목",
    emailInvalid: "이메일 형식이 올바르지 않습니다.",
    mustBeAccept: "동의해야 합니다",
    placeholderFirstName: "이름",
    placeholderLastName: "성",
    placeholderEmail: "이메일 주소",
    placeholderPhone: "전화번호",
    placeholderEnquiry: "문의 유형 선택",
    placeholderWhichHotel: "어느 호텔에 문의하시겠습니까?",
    placeholderMessage: "메시지",
    placeholderDepartureDate: "체크아웃 날짜",
    placeholderArrivalDate: "체크인 날짜",
    placeholderRoomType: "객실 유형 선택",
    placeholderAll: "전체",
    labelPhone: "전화",
  },
  Options: {
    Enquiry: {
      hotelReservation: "호텔 예약",
      wellnessReservation: "웰니스 예약",
      meetingsEvents: "회의 및 이벤트",
      pressMedia: "언론 및 미디어",
      generalEnquiryFeedback: "일반 문의 및 피드백",
    },
  },
  Notification: {
    submitSuccess: "정보가 제출되었습니다.",
  },
  Footer: {
    name: "아마나키 호텔",
    address: "타오디엔 구, 투득 시, 호치민 시",
    address10: "10 Nguyen Dang Giai, 타오디엔 구, 호치민, 베트남",
    address65: "65 Ho Tung Mau, 벤응에 구, 1구, 호치민",
    email: "info@amanaki.vn",
    email10: "info@amanaki.vn",
    email65: "sales@amanakihotels.com",
    phone: "(+84) 82 362 4488",
    phone10: "(+84) 82 362 4488",
    phone65: "(+84) 28 363 4488",
    tel: "전화",
    ourHotels: "호텔 소개",
    thaoDien: "아마나키 타오디엔",
    boutiqueSaigon: "아마나키 사이공 부티크",
    amanakiHotels: "아마나키 호텔",
    getToKnowUs: "회사 소개",
    whoWeAre: "회사 소개",
    sustainabilityImpact: "지속가능성 영향",
    ourStories: "스토리",
    explore: "둘러보기",
    careers: "채용",
    ourOffice: "사무실",
    getInTouch: "연락하기",
    contactUs: "문의하기",
    copyright: "© 2023 아마나키 호텔. 모든 권리 보유.",
    privacyPolicy: "개인정보 처리방침",
    adCookiePolicy: "광고 및 쿠키 정책",
    legalNotices: "법적 고지",
  },
  Header: {
    selectAHotel: "호텔 선택",
    aboutAmanaki: "아마나키 소개",
    ourStories: "블로그",
    contactUs: "문의하기",
    ourBlog: "블로그",
    aboutUs: "회사 소개",
    sustainability: "지속가능성",
    careers: "채용",
  },
  Button: {
    bookNow: "지금 예약",
    discoverMore: "더 알아보기",
    moreDetail: "자세히 보기",
    moreDetails: "자세히 보기",
    allOffer: "모든 특가 보기",
    viewThisRoom: "객실 보기",
    applyNow: "지금 지원",
    viewMap: "지도 보기",
    contactUs: "문의하기",
    moreAboutUs: "더 알아보기",
    enterOurSpaces: "공간 둘러보기",
    bookThisRoom: "객실 예약",
    exploreArtsAndAmanaki: "아트 & 아마나키 둘러보기",
    viewAllStories: "모든 스토리 보기",
    viewAll: "전체 보기",
    reserve: "예약",
    readMore: "더 읽기",
    exploreMore: "더 둘러보기",
    viewCareers: "채용 보기",
    makeAnEnquire: "문의하기",
    getToKnowOurExecutiveChef: "셰프 소개",
    visitOurRestaurant: "레스토랑 방문",
    seeOurFacilities: "시설 보기",
    submit: "제출",
    checkTheMap: "지도 확인",
    goToMap: "지도로 이동",
    requestForProposal: "제안 요청",
    bookDirectWithUs: "직접 예약",
    back: "뒤로",
    backToTop: "맨 위로",
  },
  FAQs: {
    FAQs: "자주 묻는 질문",
    slogan: "모든 요구사항을 충족하기 위해 여기 있습니다!",
  },
  Stories: {
    title: "영감을 주는 스토리",
    topic: {
      wellness: "웰니스",
      liveLikeLocal: "현지인처럼 살기",
      whatOn: "최신 소식",
    },
    lastestStories: "최신 스토리",
    interested: "관심사",
    exploreAllStories: "모든 스토리 둘러보기",
    tags: "태그",
    share: "스토리 공유",
  },
  About: {
    aboutAmanaki: "아마나키 소개",
    aboutUs: "회사 소개",
    sustainableDevelopment: "지속가능한 발전",
    careers: "채용",
    sustainable: {
      blogs: {
        heading: "추천 콘텐츠",
      },
    },
  },
  Wellness: {
    wellness: "웰니스",
    facilitiesService: "시설 및 서비스",
    gallery: "갤러리",
    hours: "운영 시간",
    reservations: "예약",
    location: "위치",
    wellbeingCentre: {
      wellbeingCentre: "웰빙 센터",
    },
    facilities: {
      facilities: "시설",
    },
  },
  Dinning: {
    dinning: "다이닝",
    restaurantInfo: {
      title: "레스토랑 정보",
      cuisine: {
        label: "요리",
        fusionInspired: "베트남 퓨전",
        viewMenu: "메뉴 보기",
      },
      reservations: {
        label: "예약",
        phone: "082 841 1010",
        email: "info@amanaki.vn",
        address: "8 Nguyen Dang Giai, 타오디엔, 2구",
      },
      openingHours: {
        label: "운영 시간",
        allDay: "하루 종일",
        dinning: "06:00 - 22:00",
        lastOrder: "(마지막 주문 21:45)",
      },
      executiveChef: {
        label: "셰프",
        name: "Dong Hoang Nam",
      },
      moreInfo: {
        label: "추가 정보",
        amanakiFacebook: "아마나키 Facebook",
      },
    },
  },
  MeetingAndEvents: {
    meetingAndEvents: "회의 및 이벤트",
    meetingAndCelebrations: "이벤트 및 축하",
    labelBanner: "영감을 주는 이벤트를 위한 창의적 공간",
    overview: {
      title: "아마나키 타오디엔의 이벤트 및 축하",
      desc: "문자 그대로 그리고 비유적으로, 11:11 Espace는 아마나키 타오디엔의 중심에 위치해 있습니다 - 스토리가 생성되고 교환되는 경계 공존 공간입니다. 250평방미터의 전시 및 이벤트 공간은 현대 베트남 및 국제 예술가들이 11:11 Espace가 큐레이션하고 제시한 대로 창의적 재능을 선보이는 곳입니다. 스타일리시한 아트 및 소셜 이벤트를 원하신다면, 연락 주시기 바랍니다!",
      phone: "(+84) 82 362 4488",
      email: "info@amanaki.vn",
    },
    requestForProposal: {
      form: {
        fullName: "성명",
        emailAddress: "이메일 주소",
        phoneNumber: "전화번호",
        numberOfAttendees: "예상 참석자 수",
        desiredSetup: "원하는 설정",
        desiredSetupOptions: JSON.stringify([
          { label: "연회", value: "Banquet" },
          { label: "칵테일 리셉션", value: "CocktailReception" },
          { label: "극장형", value: "Theatre" },
          { label: "U자형", value: "Ushape" },
          { label: "기타", value: "Other" },
        ]),
        eventDate: "이벤트 날짜",
        note: "이벤트 개요, 의견, 질문 및/또는 특별 요청",
        condition: {
          readAndAccept: "다음을 읽고 동의했습니다",
          privacyPolicy: "개인정보 처리방침",
          keepUpToDateInfo: "뉴스 및 정보를 최신 상태로 유지하고 싶습니다",
        },
      },
    },
  },
  BrandStory: {
    banner: {
      title: "브랜드 스토리",
    },
  },
  Arts: {
    banner: {
      title: "아트 & 아마나키",
    },
    exhibitions: {
      tabs: JSON.stringify([
        { label: "예정된 전시", value: "upcomingExhibition" },
        { label: "현재 전시", value: "currentExhibition" },
        { label: "과거 전시", value: "previousExhibition" },
      ]),
      status: {
        ongoing: "진행 중",
        exhibition: "전시",
      },
    },
  },
  LegalNotice: {
    banner: {
      title: "법적 고지",
    },
    menuOptions: JSON.stringify([
      { label: "개인정보 처리방침", value: "PrivacyPolicy" },
      { label: "쿠키", value: "Cookies" },
      { label: "최저가 보장", value: "BestRateGuaranteed" },
    ]),
    cookies: {
      heading: "쿠키",
      data: JSON.stringify([
        {
          title: `1. 쿠키란 무엇입니까?`,
          content: `쿠키는 웹사이트를 방문할 때 컴퓨터나 모바일 기기 <i>（스마트폰이나 태블릿 등）</i>에 저장되는 작은 텍스트 파일이나 정보 조각입니다. 쿠키에는 일반적으로 쿠키가 온 웹사이트의 이름, 쿠키의 "수명" <i>（즉, 쿠키가 기기에 얼마나 오래 남아 있는지）</i>, 그리고 일반적으로 무작위로 생성된 고유 번호인 값이 포함됩니다.`,
        },
        {
          title: `2. 쿠키를 사용하는 목적은 무엇입니까?`,
          content: `쿠키를 사용하여 웹사이트를 더 쉽게 사용하고 웹사이트와 제품을 귀하의 관심사와 요구에 맞게 더 잘 맞춤화합니다. 웹사이트가 이러한 파일을 읽고 쓸 수 있으므로 쿠키가 이를 수행할 수 있어 귀하를 인식하고 웹사이트 사용을 더 편리하게 만드는 중요한 정보를 기억할 수 있습니다 <i>（예: 기본 설정 기억）</i>. 쿠키는 또한 웹사이트에서 향후 활동과 경험을 더 빠르게 하는 데 사용될 수 있습니다. 또한 쿠키를 사용하여 사용자가 웹사이트를 사용하는 방식을 이해하고 웹사이트의 구조와 콘텐츠를 개선하는 데 도움이 되는 익명의 집계 통계를 컴파일합니다. 이 정보로부터 귀하를 개인적으로 식별할 수 없습니다.`,
        },
        {
          title: `3. 어떤 유형의 쿠키를 사용합니까?`,
          content: `웹사이트에서 "세션 쿠키"와 "영구 쿠키"라는 두 가지 유형의 쿠키를 사용할 수 있습니다. 세션 쿠키는 사이트를 떠날 때까지 기기에 남아 있는 임시 쿠키입니다. 영구 쿠키는 기기에 훨씬 더 오래 남아 있거나 수동으로 삭제할 때까지 남아 있습니다 <i>（쿠키가 기기에 얼마나 오래 남아 있는지는 특정 쿠키의 지속 시간 또는 "수명"에 따라 다름）</i>.
서드파티 쿠키
또한 많은 공급업체를 사용하며, 웹사이트를 방문할 때 당사를 대신하여 기기에 쿠키를 설정하여 제공하는 서비스를 제공할 수 있도록 할 수 있습니다. 이러한 쿠키에 대한 자세한 정보와 이러한 쿠키 수신을 거부하는 방법에 대한 정보는 해당 개인정보 처리방침을 참조하십시오.`,
        },
        {
          title: `4. 어떤 쿠키를 사용합니까?`,
          content: [
            {
              text: `아래에는 Amanaki.vn 웹사이트에서 사용할 수 있는 다양한 유형의 쿠키를 나열합니다. 쿠키를 통해 수집된 정보가 개인정보를 구성하는 범위 내에서 개인정보 처리방침의 조항이 적용되고 이 쿠키 정책을 보완합니다.`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">필수 쿠키：</span>
필수 쿠키는 사이트가 작동하고 사이트를 탐색하고 서비스 및 기능을 사용할 수 있도록 하는 데 필요합니다. 이러한 절대적으로 필수적인 쿠키가 없으면 사이트가 원하는 대로 원활하게 작동하지 않을 수 있으며 요청한 사이트 또는 특정 서비스나 기능을 제공하지 못할 수 있습니다.
<span style="font-weight: 405;">세션</span> – 세션 쿠키는 애플리케이션의 상태를 유지하는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">로드 밸런싱</span> – 로드 밸런싱 쿠키는 전 세계에 자산을 분산하고 서버 부하를 줄이는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">사용자 ID</span> – 사용자 ID 쿠키는 사용자가 자신의 정보만 볼 수 있도록 하는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">보안</span> – 보안 쿠키는 보안 제어 및 확인에 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">선호도 쿠키</span>
선호도 쿠키는 선택 및 선호도에 대한 정보를 수집하고 언어 또는 기타 로컬 설정을 기억하고 그에 따라 사이트를 사용자 정의할 수 있도록 합니다.
<span style="font-weight: 405;">언어</span> – 언어 쿠키는 사용자가 선택한 언어를 저장하고 올바른 옵션을 표시하는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">위치</span> – IP 주소로 결정된 사용자의 대략적인 주소 <i>（도시, 주, 국가/지역, 우편번호）</i>는 적절한 국가/지역을 자동으로 선택하고 해당 지역 내의 소매업체 및 시연일을 표시하기 위해 보관됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">모바일</span> – 사용자가 모바일 기기에서 사이트를 보는 경우 쿠키가 설정되어 메인 웹사이트가 선택되었음을 나타냅니다 <i>（즉, 기기가 Flash 지원）</i> 또는 비 Flash 모바일 사이트입니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">참조 사이트</span> – 참조 사이트는 사용자의 선호도를 더 잘 이해하기 위해 기록됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">마지막 방문 및 활동</span> – 마지막 방문 및 활동 날짜와 기타 정보가 기록되어 "마지막 방문 이후 사이트의 변경 사항"에 대한 업데이트를 사용자에게 제공하고 사용자의 선호도를 더 잘 이해할 수 있습니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">최근 시청한 동영상</span> – 최근 시청한 동영상의 날짜와 제목이 기록되어 사용자의 선호도를 더 잘 이해할 수 있습니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">Flash 쿠키</span> – Flash 쿠키는 오디오 및 비디오 콘텐츠 재생을 활성화하는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">페이지 기록</span> – 페이지 기록 쿠키는 사용자가 방문한 페이지 시퀀스를 추적하는 데 사용됩니다. 사용자가 사이트를 방문하는 동안 오류 메시지를 받으면 쿠키 정보가 오류 보고 및 해결을 위해 로그 파일에 저장됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">소셜 플러그인 추적 쿠키</span>
이러한 쿠키는 시장 조사 분석 및 제품 개발을 위해 소셜 미디어 네트워크의 회원 [및 비회원]을 추적하는 데 사용됩니다.
<span style="font-weight: 405;">Facebook</span> – 쿠키는 시장 조사 분석 및 제품 개발을 위해 Facebook 회원 [및 비회원]을 추적하는 데 사용됩니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">분석 쿠키</span>
분석 쿠키는 사이트 사용에 대한 정보를 수집하고 작동 방식을 개선할 수 있도록 합니다. 예를 들어, 분석 쿠키는 사이트에서 가장 자주 방문한 페이지를 보여주고, 사이트 사용 중 발생한 어려움을 기록하는 데 도움이 되며, 광고가 효과적인지 여부를 보여줍니다. 이를 통해 단일 사용자의 사용이 아닌 사이트의 전체 사용 패턴을 볼 수 있습니다.
<span style="font-weight: 405;">Google Analytics</span> – Google Analytics 쿠키는 사이트 프레젠테이션 및 탐색을 개선하기 위해 집계 통계 데이터를 수집합니다. Google은 인구 통계 및 관심 정보로 집계 데이터를 보완하여 방문자를 더 잘 이해할 수 있도록 합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">Adobe Omniture</span> – Adobe Omniture 분석 쿠키는 사이트 프레젠테이션 및 탐색을 개선하기 위해 집계 통계 데이터를 수집합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">마케팅 쿠키</span>
광고 쿠키는 마케팅 목적으로 사용됩니다.
<span style="font-weight: 405;">광고</span> – 행동/타겟팅 광고를 제공합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">시장 분석</span> – 시장 분석을 수행합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">캠페인/프로모션</span> – 캠페인의 효과를 측정합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.
<span style="font-weight: 405;">사기 감지</span> – 클릭 사기를 감지합니다. 브라우저 설정을 통해 수락/거부하여 관리할 수 있습니다.`,
            },
          ],
        },
        {
          title: `5. 쿠키를 관리하는 방법은 무엇입니까?`,
          content: `대부분의 인터넷 브라우저는 처음에 쿠키를 자동으로 수락하도록 설정되어 있지만, 대부분의 인터넷 브라우저를 사용하면 설정을 변경하여 쿠키를 차단하거나 쿠키가 기기로 전송될 때 알림을 받을 수 있습니다.
위에서 제공한 옵션 외에도 브라우저의 설정을 활성화하거나 액세스하여 언제든지 사이트의 쿠키를 거부, 수락 또는 제거할 수 있습니다. 쿠키를 활성화, 비활성화 또는 제거하기 위해 따라야 하는 절차에 대한 정보는 도움말 화면을 통해 인터넷 브라우저 공급업체의 웹사이트에서 찾을 수 있습니다.
쿠키가 비활성화되거나 제거되면 사이트의 모든 기능이 의도한 대로 작동하지 않을 수 있습니다. 예를 들어, 사이트의 특정 영역을 방문하지 못하거나 사이트를 방문할 때 개인화된 정보를 받지 못할 수 있습니다.
다른 기기를 사용하여 웹사이트를 보고 액세스하는 경우 <i>（예: 컴퓨터, 스마트폰, 태블릿 등）</i> 각 기기의 각 브라우저가 쿠키 기본 설정에 맞게 조정되어 있는지 확인해야 합니다.
방문한 웹사이트가 남긴 모든 쿠키를 정리하려면 추적 쿠키를 정리하는 서드파티 웹사이트를 찾을 수 있습니다.
이러한 서드파티 웹사이트는 당사의 통제 하에 있지 않으며 이러한 웹사이트와 관련하여 어떠한 진술이나 보증도 하지 않습니다. 이러한 서드파티 웹사이트에 액세스하기로 결정한 경우 사이트를 사용하기 전에 해당 서드파티 사이트의 각 약관 및 조건과 개인정보 처리방침을 검토하는 것이 좋습니다.`,
        },
        {
          title: `6. 픽셀 태그`,
          content: `사이트에서 방문하는 일부 페이지는 프로모션 활동 및 웹사이트 개발을 직접 지원하는 서드파티와 공유될 수 있는 픽셀 태그 <i>（명확한 gif라고도 함）</i> 사용을 통해 정보를 수집할 수도 있습니다. 예를 들어, 웹사이트 방문자에 대한 웹사이트 사용 정보는 웹사이트의 인터넷 배너 광고를 더 잘 타겟팅하기 위해 서드파티 광고 대행사와 공유될 수 있습니다. 그러나 이러한 픽셀 태그 사용을 통해 수집된 정보는 개인적으로 식별 가능하지 않지만 개인정보와 연결될 수 있습니다.`,
        },
        {
          title: `7. 문의하기`,
          content: `이 쿠키 정책에 대한 질문이 있으시면 <a href="mailto:info@amanaki.vn" style="color: #af915e">info@amanaki.vn</a>으로 문의하십시오. 이메일 통신이 항상 안전한 것은 아니므로 이메일에 신용카드 정보나 민감한 정보를 포함하지 마십시오.`,
        },
      ]),
    },
    bestRateGuaranteed: {
      heading: "최저가 보장",
      title: "아마나키에 직접 예약하여 최저가를 보장받으세요.",
      data: JSON.stringify([
        {
          content: `아마나키에서의 숙박은 처음부터 끝까지 저희의 우선순위입니다. 공식 웹사이트에서 직접 숙박을 예약할 때 여정이 시작되며 다음을 보장받게 됩니다:`,
        },
        {
          content: [
            `숙박에 대한 최저가`,
            `가장 유연한 취소 조건`,
            `예약을 도와줄 전담 예약 전문가 이용`,
            `숙박 기간 동안 최고의 서비스 이용`,
            `예약 후 24시간 이내에 더 낮은 적격 요금을 찾으면 더 낮은 요금에 맞춰드립니다.`,
          ],
        },
      ]),
    },
  },
  HomeHotel10: {
    experiencing: {
      title: "아마나키 체험",
    },
  },
  Offers: {
    offer: "특가",
  },
  Offer: {
    valid: "{{date}}까지 유효",
    otherOffer: "기타 특가",
  },
  ContactUs: {
    description: `호텔, 호텔 예약 또는 레스토랑이나 웰빙 센터 예약에 대한 질문이 있으시면 문의하십시오.`,
    getInTouch: "연락하기",
    descInTouch: `연락 주시면 기쁘게 답변드리겠습니다. 아래 세부 정보를 사용하여 문의하십시오.`,
    iConfirm: "아마나키 호텔의 다음을 읽고 이해했음을 확인합니다",
    privacy: "개인정보 처리방침",
    acceptReceiveInfomation:
      "예! 호텔, 다이닝 및 스파 프로모션을 포함하여 아마나키 호텔의 특별 혜택 및 프로모션을 받고 싶습니다",
    addressAmanakiThaoDien: `10 Nguyen Đang Giai, 타오디엔 구, 투득 시, 호치민 시`,
    addressAmanakiSaigonBoutique: `65 Ho Tung Mau, 벤응에 구, 1구, 호치민`,
  },
  Discover: {
    title: "사이공 둘러보기",
    description:
      "\"모든 건물, 모든 상점 앞면이 다른 세계로 열리는 것처럼 보였고, 인간 삶의 모든 다양성을 가능성의 혼란으로 압축하여 접속사로 인해 더욱 풍부해졌습니다.\"<0/>Rebecca Solnit",
    BlockLocation: {
      distanceAmanaki: "아마나키에서의 방향:",
      checkMap: "지도 확인",
    },
    BlockOurLocation: {
      ourLocation: "위치",
      getting: "아마나키<0/>타오디엔 호텔로 가기",
      address: "10 Nguyen Dang Giai 거리, 타오디엔 구, 투득 시, 호치민 시",
      phone: "(+84) 82 3624488",
      airport: "떤선녓 국제공항",
      airportDescription: `떤선녓 국제공항에서<0/>
호텔까지 거리: 13km<0/>
공항 셔틀 서비스: 500,000동/회`,
      tel: "전화",
    },
  },
  Breadcrumb: {
    stories: "스토리",
    category: "카테고리",
    amanakiThaoDien: "아마나키 타오디엔",
    "amanaki-thao-dien": "아마나키 타오디엔",
    "amanaki-boutique-saigon": "아마나키 사이공 부티크",
    theHotel: "호텔",
  },
  Rooms: {
    Signature: "시그니처",
    Executive: "이그제큐티브",
    Premium: "프리미엄",
    FamilySuite: "패밀리 스위트",
    otherRooms: "기타 객실",
    theDetails: "상세 정보",
    utilities: "시설",
    amenities: "편의 시설",
    checkIn: "체크인",
    checkOut: "체크아웃",
    visitOurRooms: "객실 둘러보기",
    Banner: {
      title: "객실 둘러보기",
      description: `천천히 걸으며 눈을 크게 뜨세요.<0/>안으로 들어가면 역사의 한 조각이 부드럽게 당신을 바라보고 있습니다.`,
    },
  },
  DateFormat: {
    Default: "DD/MM/YYYY",
    FullDisplay: "HH:mm:ss - DD/MM/YYYY",
    Unit: {
      second: "초",
      minute: "분",
      hour: "시간",
    },
    Time: "LT",
  },
  SearchControl: {
    room: "객실",
    adults: "성인",
    children: "어린이",
    bestPrice: "최저가 보장",
    checkAvailability: "예약 가능 여부 확인",
  },
  Time: {
    minutes: "{{n}}분",
  },
  Filter: {
    clearFilter: "필터 지우기",
    categoryPlaceholder: "카테고리",
    placeholderCategory: "카테고리",
    sortPlaceholder: "정렬",
    lastestLabel: "최신 기사",
    oldestLabel: "오래된 기사",
  },
  Error: {
    pageNotFound: "페이지를 찾을 수 없습니다",
    pageNotFoundDescription: "찾고 있는 페이지가 존재하지 않거나 이동되었습니다.",
    serverError: "서버 오류",
    serverErrorDescription: "서버에 문제가 발생했습니다. 나중에 다시 시도해 주세요.",
    goHome: "홈으로 이동",
  },
  CookieConsent: {
    message: "사이트 경험 개선 및 트래픽 분석을 위해 쿠키를 사용합니다. 수락을 클릭하면 쿠키 사용에 동의하는 것입니다. 자세한 내용은",
    privacyPolicy: "개인정보 처리방침",
    acceptAll: "모두 수락",
    rejectAll: "모두 거부",
    managePreferences: "환경설정 관리",
    preferencesTitle: "쿠키 환경설정",
    preferencesDescription: "허용할 쿠키를 선택하세요. 언제든지 설정을 변경할 수 있습니다. 자세한 내용은",
    savePreferences: "환경설정 저장",
    cancel: "취소",
    categoryNecessary: "필수",
    categoryFunctional: "기능",
    categoryAnalytics: "분석",
    categoryMarketing: "마케팅",
    alwaysRequired: "항상 켜짐",
    categoryNecessaryDesc: "웹사이트 작동에 필요합니다. 비활성화할 수 없습니다.",
    categoryFunctionalDesc: "언어 및 지역과 같은 환경설정을 기억합니다.",
    categoryAnalyticsDesc: "방문자가 사이트를 어떻게 사용하는지 이해하여 개선하는 데 도움을 줍니다.",
    categoryMarketingDesc: "맞춤형 광고 및 마케팅 캠페인에 사용됩니다.",
    toggleLabel: "쿠키 카테고리 전환",
    cookiePreferences: "쿠키 환경설정",
  },
};
export default ko;

